import React, { ComponentProps, FC, ReactNode } from 'react';
import Modal from '@/components/Common/Modal';
import { Text } from '@/components/Common/Text';
import { TextScale } from '@/components/Common/Text/Text';
import * as styles from './DialogModal.module.scss';

type Props = ComponentProps<typeof Modal> & {
  title: ReactNode;
};

const DialogModal: FC<Props> = ({ title, children, ...props }) => (
  <Modal {...props}>
    <div className={styles.card}>
      <Text as="h2" scale={TextScale.Headline} level={2}>
        {title}
      </Text>
      {children}
    </div>
  </Modal>
);

export default DialogModal;
